type BorderJoinStyle = 'miter' | 'round' | 'bevel';

export interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    data: number[];
    borderColor: string;
    borderJoinStyle: BorderJoinStyle;
    borderDash?: number[];
    tension: number;
    borderWidth?: number;
    pointBackgroundColor?: string;
    pointBorderWidth: number;
    pointHitRadius: number;
    fill: boolean;
    backgroundColor: string;
  }[];
}

export const getLineChartSettings = (
  chartData: { moisture: number; timestamp: string }[]
): ChartData => {
  const labels = chartData.map((data) => {
    const date = new Date(data.timestamp);
    return date.toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric', 
    });
  });
  
  return {
    labels: labels,
    datasets: [{
      label: "Soil Moisture",
      data: chartData.map((data) => data.moisture * 10),
      borderColor: "#265FC2",
      borderJoinStyle: "round" as BorderJoinStyle,
      // borderDash: [2],
      tension: .4,
      borderWidth: 1,
      pointBorderWidth: 3,
      pointHitRadius: 10,
      fill: true,
      backgroundColor: "rgba(38, 95, 194, 0.2)",
    }],
  };
};
